import { Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { OfferCardData, OfferCardDataDriver, OfferCardDataInformationIcon, OfferCardDataPrice, OfferCardType } from '../offer-card-data.model';
import { LoyaltyMode } from '@shopping-angular-components/loyalty';
import { ReplaceParamsPipe } from 'projects/common/pipes/replace-params.pipe';
import { Currency } from 'projects/common/model/landingModel';

@Component({
  selector: 'offer-card-info',
  template: `
    <div class="{{offerCardType}}">
      <span *ngIf="outstandingDriverData" class="eva-3-driver offer-card-main-driver" [ngClass]="outstandingDriverData.driver_style">
        <span class="driver-text" [ngClass]="outstandingDriverData.text_style">
          <img *ngIf="outstandingDriverData.icon_src"
            [ngClass]="outstandingDriverData.icon ? outstandingDriverData.icon : ''"
            [src]="'/landings-static/' + outstandingDriverData.icon_src"
            loading="lazy" alt="icon">
          <i class="-eva-3-mr-xsm" [ngClass]="outstandingDriverData.icon"
              *ngIf="outstandingDriverData.icon && !outstandingDriverData.icon_src"></i>
          {{outstandingDriverData.text}}
        </span>
      </span>

      <div class="offer-card-product -eva-3-mt-sm" *ngIf="data.product_text">{{data.product_text}}</div>
      <a href="{{href}}" class="offer-card-title link small-title" [ngClass]="data.product_text ? '-eva-3-mt-xsm' : '-eva-3-mt-sm'" 
        *ngIf="data.main_text" target="_blank" (click)="onTitleClick($event)">{{data.main_text}}</a>

      <ng-container [ngTemplateOutlet]="offerCardDescriptions" *ngIf="isHotelOrVr"></ng-container>

      <div class="offer-card-rating" *ngIf="data.overall_rating || (data.information_icons && data.information_icons.length > 0)">
        <span *ngIf="data.additional_info" class="-eva-3-mr-xsm offer-card-rating-additional-info">{{data.additional_info}}</span>
        <ng-container *ngIf="data.overall_rating">
          <review-score 
            [score]="data.overall_rating" 
            [size]="'-sm'"
            [overallRatingDescription]="data.overall_rating_description"
            [overallRatingDescriptionStyle]="data.overall_rating_description_style">
          </review-score>
          <review-total-comments *ngIf="data.total_comments_text" [count]="data.total_comments_text"></review-total-comments>
          <div class="offer-card-rating-stars" *ngIf="data.stars">
            <i *ngFor="let star of stars" class="-eva-3-icon-xsm eva-3-icon-star-filled"></i>
          </div>
        </ng-container>

        <div *ngIf="data.overall_rating && data.information_icons" class="divider"></div>
        <div class="offer-card-icons-container" *ngIf="data.information_icons && data.information_icons.length > 0">
          <div *ngFor="let icon of data.information_icons" class="icon-container">
            <tooltip backgroundColor="-white" position='-top -right' [openOnHover]="hasTooltipText(icon)" product="nymeria-gui" flow="landing">
              <span label class="icon-information">
                <i [ngClass]="'eva-3-icon-'+icon.icon" class="-eva-3-icon-sm"></i>
              </span>

              <p tooltip-content class="tooltip-text">{{icon.tooltip_text}}</p>
            </tooltip>
          </div>
        </div>
      </div>

      <div *ngIf="data.description && data.highlights && offerCardType === 'WOW'" class="-eva-3-mt-md">
        <div class="offer-card-description">{{data.description}}</div>
        <ul class="-eva-3-mt-md">
          <li *ngFor="let item of data.highlights" class="offer-card-highlight-item">
            <span>{{item}}</span>
          </li>
        </ul>
      </div>

      <div *ngIf="data.information_list" class="offer-card-information-list eva-3-caption -eva-3-mt-md">
        <ul class="-eva-3-mb-md">
          <li *ngFor="let item of data.information_list" class="offer-card-information-list-item -eva-3-mb-sm">
            <i class="-eva-3-icon-xsm eva-3-icon-{{item.icon}} -eva-3-mr-sm"></i>
            <span>{{item.text}}</span>
          </li>
        </ul>
      </div>

      <div class="offer-card-room-type eva-3-h6 -eva-3-tc-gray-0" *ngIf="data.room_type_description">
        {{data.room_type_description}}
      </div>

      <ng-container [ngTemplateOutlet]="offerCardDescriptions" *ngIf="!isHotelOrVr"></ng-container>

      <div *ngIf="(data.dates?.from?.text || data.dates?.to?.text) && price?.promo?.promo_type === 'HOTSALE'">
        <div class="offer-card-description">{{'offers.smallText.dates' | translate}}</div>
        <div class="offer-dates-container">
          <span class="offer-date-label -eva-3-tc-gray-1 -eva-3-mb-sm">{{'offers.smallText.dates' | translate}}</span>
          <span class="offer-date-wrapper" *ngIf="data.dates.from?.text">
              <em class="offer-date -eva-3-tc-gray-1 -eva-3-bold">{{data.dates.from!.text}}</em>
            </span>

          <span class="offer-date-wrapper" *ngIf="data.dates.to?.text">
              <em class="offer-date -eva-3-tc-gray-1 -eva-3-bold">{{data.dates.to!.text}}</em>
            </span>
        </div>
      </div>
    </div>

    <ng-template #offerCardDescriptions>

      <div *ngIf="data.auxiliary_text" class="offer-card-description auxiliary-text">
        <i *ngIf="offerCardType === 'REDUCED'" class="eva-3-icon-departure -eva-3-icon-sm"></i>
        <span [ngClass]="{'-eva-3-ellipsis': offerCardType === 'REDUCED'}" [innerHTML]="data.auxiliary_text"></span>
      </div>
      <div *ngIf="data.small_text && offerCardType !== 'REDUCED'" class="offer-card-description small-text-description">{{data.small_text}}</div>
    </ng-template>
`,
  styleUrls: ['./offer-card-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OfferCardInfoComponent implements OnInit, OnChanges {
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() positionIndex: number;

  @Input() data: OfferCardData;
  @Input() currency?: Currency;
  @Input() locale: string;
  @Input() flow: string;
  @Input() product: string;

  @Input() loyaltyMode: LoyaltyMode | null;
  @Input() offerCardType: OfferCardType;
  @Input() sboxAutocomplete?: boolean;

  stars: Array<any> = [];
  price: OfferCardDataPrice;
  isHotelOrVr: boolean;
  outstandingDriverData?: OfferCardDataDriver;
  href: string | null;

  constructor(private replaceParamsPipe: ReplaceParamsPipe) { }

  ngOnInit(): void {
    this.initStars();
    this.isHotelOrVr = ['hotels', 'vacation_rentals'].includes(this.data.product);
    if (this.data.outstanding_driver || this.data.outstanding_text) {
      this.outstandingDriverData = {
        text: this.data.outstanding_text,
        type: "",
        driver_style: "-information",
        text_style: "",
        icon: "",
        ...(this.data.outstanding_driver || {})
      };
    }
    if (this.currency) {
      this.initPrice();
      this.href = this.getHref();
    }
  }

  ngOnChanges(): void {
    this.initPrice();
    this.href = this.getHref();
  }

  private initStars(): void {
    if (this.data.stars) {
      this.stars = new Array(Number(this.data.stars)).fill({});
    }
  }

  hasTooltipText(icon: OfferCardDataInformationIcon): boolean {
    return !!icon?.tooltip_text;
  }

  onTitleClick(event: MouseEvent) {
    if (this.sboxAutocomplete && this.isHotelOrVr) {
      event.preventDefault();
    }
  }

  private initPrice(): void {
    if (this.currency) {
      if (this.data?.offer_alternatives) {
        this.price = this.data.offer_alternatives[0].price[this.currency.code];
      } else if (this.data.price) {
        this.price = this.data.price[this.currency.code];
      }
    }
  }

  private getHref(): string | null {
    if ((this.data.offer_alternatives?.length || 0) > 0) {
      return null;
    }
    const url = this.data.force_domain ? `https://${this.data.force_domain}${this.data.link.url}` : this.data.link.url;
    return this.replaceParamsPipe.transform(url, { currency: this.currency?.code, price: this.price?.total_amount_not_formatted });
  }
}
